export default function getUrlWithAccountAndWorkspace(url: string, accountId: number, workspaceId: number): string {
  const urlParams = `accountId=${accountId}&workspaceId=${workspaceId}`
  const urlHasAlreadyParams = url.includes('?')
  
  return urlHasAlreadyParams ? `${url}&${urlParams}` : `${url}?${urlParams}`
}
